import { Heading, PlaceCenter, Spinner } from '@components'
import type { Setup } from '@here/api'
import { Ghost } from 'lucide-solid'
import { type Component, For, Show } from 'solid-js'
import { useService } from 'solid-services'
import { css } from 'styled-system/css'
import { Grid } from 'styled-system/jsx'
import Card from '../Card'
import { useList } from '../state'

export const Items: Component<{
	list: (Setup & { count?: number })[]
}> = (props) => {
	const { activeLayout, isLoading } = useService(useList)()

	return (
		<Show
			when={props.list.length || isLoading()}
			fallback={
				<PlaceCenter>
					<Grid
						justifyItems="center"
						gap={4}
					>
						<Heading
							size="3xl"
							children="No setups found"
						/>
						<Ghost size={150} />
					</Grid>
				</PlaceCenter>
			}
		>
			<main
				class={css({
					display: 'grid',
					gap: '3',
					gridTemplateColumns: {
						base: 'repeat(auto-fill, minmax(450px, 1fr))',
						smDown: '1fr',
					},
				})}
			>
				<Show when={isLoading()}>
					<PlaceCenter
						children={
							<Spinner
								marginTop="-125px"
								colorPalette="tscGreen"
								position="fixed"
								zIndex={9999}
							/>
						}
					/>
				</Show>
				<For each={props.list}>
					{(item) => (
						<Card
							layout={activeLayout()}
							setup={item}
						/>
					)}
				</For>
			</main>
		</Show>
	)
}
